(function () {
  var intro = document.getElementById('rnt-intro');
  if (!intro) return;
  var enter = document.getElementById('rnt-enter');
  try { if (sessionStorage.getItem('rntWorldEntered') === 'yes') intro.classList.add('is-hidden'); } catch (e) {}
  enter.addEventListener('click', function () {
    intro.classList.add('is-leaving');
    try { sessionStorage.setItem('rntWorldEntered', 'yes'); } catch (e) {}
    window.setTimeout(function () { intro.classList.add('is-hidden'); document.body.classList.add('rnt-world-entered'); }, 650);
  });
})();
